import { TemplateApiModel } from './template.model';

export type PointStyleApiModel = {
  id: number;
  name: string;
  dateModified?: Date | null;
};

export type WithTemplates = PointStyleApiModel & { templates: TemplateApiModel[] };

export enum PointStyleRelationship {
  TEMPLATES = 'TEMPLATES',
}
